import { Form, Input, InputRef } from 'antd';
import Modal from 'components/Modal';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
const FormStyled = styled(Form)`
.ant-form-item .ant-form-item-label label {
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 166.667%;
  text-transform: capitalize;
}
.ant-input {
  height: 5rem;
  font-weight: 600;
  font-size: 1.8rem;
  text-align: center;
}
`;
type Props = {};
type IFormDataValues = {
  name: string;
};
type ICallBack = (data: IFormDataValues) => void;
type Ref = {
  open: (data: IFormDataValues, onDone: ICallBack) => void;
};
export const useModalEditNameRef = () => useRef<Ref>(null);
const ModalEditName = forwardRef<Ref, Props>(({ }, ref) => {
  const inputRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const callbackRef = useRef<ICallBack | undefined>();
  const onClose = () => setOpen(false);

  const onOpen: Ref['open'] = (data, onDone) => {
    form.resetFields();
    callbackRef.current = onDone || undefined;
    setOpen(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const handleFinish = (values: IFormDataValues) => {
    callbackRef?.current?.(values);
    onClose();
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  return (
    <Modal onSubmit={() => form.submit()} v2 modalTitle='edit Name' visible={open} onClose={onClose} width={900} noneBodyStyle noneFooterStyle containerPadding={1}>
      <FormStyled<any> form={form} onFinish={handleFinish} layout='vertical'>
        <Form.Item name={'name'} label='Customer Name' rules={[{ required: true, message: 'Please enter' }]}>
          <Input ref={inputRef} autoFocus placeholder='Edit name' />
        </Form.Item>
      </FormStyled>
    </Modal>
  );
});
ModalEditName.displayName = 'ModalEditName';
export { ModalEditName };
